import React from "react"
import { useLocation } from "react-router-dom";
import {
  Alert,
  Container
} from 'design-react-kit';
import SibaBreadcrumb from "../components/common/SibaBreadcrumb";
import SibaTitoloPagina from "../components/common/SibaTitoloPagina";
import * as Constants from '../utils/constants'

export function Whoops404() {
  let location = useLocation();
  console.log(location);
  return (
    <main>
      <SibaBreadcrumb />
      <SibaTitoloPagina titolo={Constants.STR_404_TITOLO} />

      <Container className="px-4 my-4" id="404" tag="section">
        <Alert color="danger">ERRORE 404: non &egrave; stato possibile trovare la pagina "<strong>{location.pathname}</strong>"</Alert>
      </Container>
    </main>
  )
}